import { get } from '~/utils/adapi';
import Debug from '~/utils/debug';

const debug = Debug('store:searchTable');

const SET_DATA = 'SET_DATA';
const SET_ENDPOINT = 'SET_ENDPOINT';
const SET_LOADING = 'SET_LOADING';
const SET_LOADING_ENDPOINT = 'SET_LOADING_ENDPOINT';

const defaultData = {
  count: {
    total: 0,
    filtered: 0,
  },
  items: [],
};


const actions = {
  search({ commit, state, rootGetters }, data) {
    commit(SET_LOADING, true);
    commit(SET_LOADING_ENDPOINT, data.endpoint);
    // Remove data if endpoint changes, to prevent wrong data SearchTable
    if (state.endpoint !== data.endpoint) {
      commit(SET_DATA, { data: defaultData, error: null });
      commit(SET_ENDPOINT, data.endpoint);
    }
    return get(data.endpoint, data.request)
      .then(result => {
        if (state.endpoint === data.endpoint) {
          commit(SET_DATA, { data: result, error: null });
          commit(SET_LOADING, false);
        } else {
          debug(
            'ignored result %o (endpoint mismatch req:%s vs s:%s)',
            result,
            data.endpoint,
            state.endpoint,
          );
        }
      })
      .catch(error => {
        if (state.endpoint === data.endpoint) {
          commit(SET_DATA, { data: defaultData, error });
          commit(SET_LOADING, false);
        } else {
          debug(
            'ignored error %o (endpoint mismatch req:%s vs s:%s)',
            error,
            data.endpoint,
            state.endpoint,
          );
        }
      });
  },
};

const mutations = {
  [SET_DATA](state, { data, error }) {
    state.data = data;
    state.error = error;
  },
  [SET_ENDPOINT](state, endpoint) {
    state.endpoint = endpoint;
  },
  [SET_LOADING](state, loading) {
    state.loading = loading;
  },
  [SET_LOADING_ENDPOINT](state, endpoint) {
    state.loadingEndpoint = endpoint;
  },
};

export default {
  namespaced: true,
  state: {
    endpoint: null,
    data: defaultData,
    error: null,
    loading: false,
    loadingEndpoint: null,
  },
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/store/modules/searchTable.js